import {options} from 'options'
import {mute, unmute} from 'audio/playAudio'

function bindControls() {
  const muteButton = document.querySelector('#muteButton')
  const ccButton = document.querySelector('#ccButton')
  const helpButton = document.querySelector('#helpButton')
  handleButton('muted', muteButton)
  handleButton('cc', ccButton)
  muteButton.addEventListener('click', () => {
    handleButton('muted', muteButton)
  })
  ccButton.addEventListener('click', () => {
    handleButton('cc', ccButton)
  })
  helpButton.addEventListener('click', () => {
    handleHelpButton(helpButton)
  })
  // set up help box
  const helpBox = document.querySelector('#help-box')
  helpBox.addEventListener('click', () => {
    if( document.body.classList.contains('show-help-box') ) {
      handleHelpBox()
    }
  })
  document.body.classList.add('hide-help-box') // initial state
}

function handleButton(setting, button) {
  if( button.classList.contains('off') ) {
    options[setting] = true
    button.classList.remove('off')
    button.classList.add('on')
  }
  else {
    options[setting] = false
    button.classList.remove('on')
    button.classList.add('off')
  }
  if(setting === 'muted') {
    if( options.muted == true ) {
      mute()
    }
    else {
      unmute()
    }
  }
  if(setting === 'cc') {
    if( options.cc == true ) {
      document.body.classList.remove('cc-off')
      document.body.classList.add('cc-on')
    }
    else {
      document.body.classList.remove('cc-on')
      document.body.classList.add('cc-off')
    }
  }
}

function handleHelpBox() {
  const showClass = 'show-help-box'
  const outClass = 'hiding-help-box'
  const hideClass = 'hide-help-box' // to completely hide after transitioning
  if( document.body.classList.contains(showClass) ) {
    document.body.classList.remove(showClass)
    document.body.classList.add(outClass)
    setTimeout( () => {
      document.body.classList.add(hideClass)
      document.body.classList.remove(outClass)
    }, 500 )
  }
  else {
    document.body.classList.remove(hideClass)
    document.body.classList.add(showClass)
  }
}

function handleHelpButton() {
  handleHelpBox()
}

function showHelpButton() {
  document.body.classList.add('show-help-button')
}

function hideHelpButton() {
  document.body.classList.remove('show-help-button')
}

export {bindControls, showHelpButton, hideHelpButton}
